import React from 'react'
import { DiJavascript1, DiReact, DiMongodb, DiPython } from 'react-icons/di'
import { SiFirebase, SiAmazonaws, SiPostgresql, SiMysql, SiGooglecloud, SiFastapi } from 'react-icons/si'

const skills = [
  { icon: <DiPython />, label: 'Python' },
  { icon: <SiFastapi />, label: 'FastAPI' },
  { icon: <DiJavascript1 />, label: 'JavaScript' },
  { icon: <DiReact />, label: 'React' },
  { icon: <DiMongodb />, label: 'MongoDB' },
  { icon: <SiPostgresql />, label: 'PostgreSQL' },
  { icon: <SiMysql />, label: 'MySQL' },
  { icon: <SiAmazonaws />, label: 'AWS' },
  { icon: <SiGooglecloud />, label: 'GCP' },
  { icon: <SiFirebase />, label: 'Firebase' },
]

function Techstack() {
  return (
    <div className="skills-grid">
      {skills.map(s => (
        <div key={s.label} className="skill-chip">
          {s.icon}
          <span>{s.label}</span>
        </div>
      ))}
    </div>
  )
}

export default Techstack
